module.exports = __webpack_public_path__ + "img/album-InRainbows.d537f595.jpg";